/**
 * テキストをクリップボードにコピーする
 * @param text コピーする文字列
 */
export const copyToClipboard = (text: string): Promise<void> =>
  navigator.clipboard.writeText(text);
